import { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import "./Admin.css";

import { API_BASE_URL } from "../../config";

const Login = () => {
    const [email, setEmail] = useState("");
    const [password, setPassword] = useState("");
    const [error, setError] = useState("");
    const [loading, setLoading] = useState(false);
    const navigate = useNavigate();

    useEffect(() => {
        // Redirect if already logged in
        const token = localStorage.getItem("admin_token");
        if (token) {
            navigate("/admin/anubhava-montessori/qwerzxcv6909/blogs");
        }
    }, [navigate]);

    const handleSubmit = async (e) => {
        e.preventDefault();
        setError("");
        setLoading(true);
 
        try {
            const response = await fetch(`${API_BASE_URL}/api/auth/login`, {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                },
                body: JSON.stringify({ email, password }),
            });

            const data = await response.json();

            if (!response.ok) {
                throw new Error(data.message || "Failed to log in.");
            }

            localStorage.setItem("admin_token", data.token);
            navigate("/admin/anubhava-montessori/qwerzxcv6909/blogs");
        } catch (err) {
            setError(err.message || "Something went wrong. Please try again.");
        } finally {
            setLoading(false);
        }
    };

    return (
        <div className="admin-login-wrapper">
            <div className="login-card">
                <div className="login-header">
                    <h2>Anubhava Montessori</h2>
                    <p>Admin Dashboard Portal</p>
                </div>

                <form onSubmit={handleSubmit} className="login-form">
                    {error && <div className="login-error-msg">{error}</div>}

                    <div className="form-group">
                        <label htmlFor="email">Email Address</label>
                        <input
                            type="email"
                            id="email"
                            placeholder="admin@anubhavamontessori.com"
                            value={email}
                            onChange={(e) => setEmail(e.target.value)}
                            required
                        />
                    </div>

                    <div className="form-group">
                        <label htmlFor="password">Password</label>
                        <input
                            type="password"
                            id="password"
                            placeholder="•••••••••••••"
                            value={password}
                            onChange={(e) => setPassword(e.target.value)}
                            required
                        />
                    </div>

                    <button type="submit" className="login-submit-btn" disabled={loading}>
                        {loading ? "Authenticating..." : "Sign In to Portal"}
                    </button>
                </form>
            </div>
        </div>
    );
};

export default Login;
